import { token } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from '../constants';
import { getBreakpointsForHeaderVersion } from '../utils/getBreakpointsForHeaderVersion';

export const ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX = {
    DESKTOP: 80,
    MOBILE: 60,
};

export type ZillowNavbarHeaderProps = {
    /** Used to determine the background color of the header */
    version: HEADER_VERSIONS;
    /** Used to determine the background color of the header */
    isMobileNavOpen: boolean;
};

export const ZillowNavbarHeader = styled.header<ZillowNavbarHeaderProps>`
    ${({ version, isMobileNavOpen }) => {
        const baseStyling = css`
            position: static;
            height: ${ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX.DESKTOP}px;
            z-index: 1000;
            @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                height: ${ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX.MOBILE}px;
            }
        `;
        switch (version) {
            case HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY: {
                return css`
                    ${baseStyling};
                    background-color: ${token('colors.backgroundWhite')};
                    border-bottom: 1px solid ${token('colors.borderLight')};
                    ${!isMobileNavOpen &&
                    css`
                        @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                            background-color: transparent;
                            border-bottom: 0px solid transparent;
                        }
                    `}
                `;
            }
            case HEADER_VERSIONS.DEFAULT:
            case HEADER_VERSIONS.SEARCH_MOBILE_ONLY:
            case HEADER_VERSIONS.ZHL_DEFAULT: {
                return css`
                    ${baseStyling};
                    background-color: ${token('colors.backgroundWhite')};
                    border-bottom: 1px solid ${token('colors.borderLight')};
                `;
            }
        }
    }}
`;
